<template>
  <div class="noti">
    <div v-if="icon == 'delete'" class="noti__icon__delete">
      <div class="noti__icon__wrapper">
        <i class="fa-solid fa-trash"></i>
      </div>
    </div>
    <div  v-if="icon == 'add'" class="noti__icon__add">
      <div class="noti__icon__wrapper">
        <i class="fa-solid fa-plus"></i>
      </div>
    </div>
    <div  v-if="icon == 'edit'" class="noti__icon__edit">
      <div class="noti__icon__wrapper">
        <i class="fa-solid fa-pen-to-square"></i>
      </div>
    </div>
    <div  v-if="icon == 'alert'" class="noti__icon__edit">
      <div class="noti__icon__wrapper">
        <i class="fa-solid fa-triangle-exclamation"></i>
      </div>
    </div>
    <div class="noti__text">
        <p>{{ tekst }}</p>
    </div>
  </div>
</template>

<script>
export default {
    props:["tekst", "icon"],
    inject:["notification"],
    created(){
      this.notification.status = true
      setTimeout(()=>{
          this.notification.status = false
      }, 4000)
    }
}
</script>